import Rest from '../Rest'
import { snakeCase } from 'lodash'

export default class GenericService extends Rest {

  /**
     * @type {String}
     */
  static resource = '/api/v1/'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getFormHandlingStatus(){
    return this.get(`form_handling/status`)
  }

  getFormTypes(){
    return this.get(`form_types`)
  }
}
